import { render, staticRenderFns } from "./User.vue?vue&type=template&id=363cf223&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=363cf223&prod&scoped=true&lang=css&external"
import style1 from "./User.vue?vue&type=style&index=1&id=363cf223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363cf223",
  null
  
)

export default component.exports